import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { memo, useCallback } from "react";
// import { createDoctor, updateDoctorById, getDoctorById } from "../../../../../services/doctor.service";
import { TDoctorForm, doctorSchema } from "./doctorSchema";
import { FormContainer, FormInput, Treturn } from "@4uhub/lib4uhub";
import { doctorItems } from "../doctor.mock";

interface IDoctorProps {
  id?: string;
  onBackButton: () => void;
}

const translationPath = "page.4uDlist.generationRule.doctor.";

export const Doctor = memo(({ id, onBackButton }: IDoctorProps) => {
  const { t } = useTranslation();

  //   const { sendRequest: save, loading: sLoading } = useFetch(
  //     createDoctor
  //   );

  //   const { sendRequest: update, loading: uLoading } = useFetch(
  //     updateDoctorById
  //   );

  //   const { sendRequest: get, loading: gLoading } = useFetch(
  //     getDoctorById
  //   );

  const saveHandler = async (v: TDoctorForm) => {
    // save({
    //   ...v,
    // });
    return { data: {}, success: true };
  };

  const updateHandler = async (v: TDoctorForm, id: string) => {
    // update({
    //   item: {
    //     ...v,
    //   },
    //   id: id,
    // });
    return { data: {}, success: true };
  };

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TDoctorForm>> => {
      //   const { data, success } = await get(id);
      //   if (data && success) {
      //     const newData: TDoctorForm = {
      //       ...data,
      //     };
      //     return { data: newData, success: true };
      //   }

      //   return { data, success };

      const data = doctorItems.find((item) => item.id === id);
      if (data) {
        return { data, success: true };
      }

      return { data: null, success: false };
    },
    [],
  );

  const successHandle = () => {
    onBackButton();
  };

  //   const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TDoctorForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      //   loading={loading}
      title={t(translationPath + "doctor")}
      schema={doctorSchema}
      subtitle={t(translationPath + "new_doctor")}
      backButtonOnClick={onBackButton}
      redirectOnSave={false}
      onSuccess={successHandle}
      isModalForm={true}
      propId={id}
      formActionsOnBottom={false}
      fields={() => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormInput
              name="sector"
              label={t(translationPath + "sector")}
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
      )}
    />
  );
});
